import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/home/Hero';
import FeaturedBreweries from '../../components/home/FeaturedBreweries';
import HowItWorks from '../../components/home/HowItWorks';
import BlogHighlights from '../../components/home/BlogHighlights';
import Pricing from '../../components/home/Pricing';
import CallToAction from '../../components/home/CallToAction';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Cerveja Delivery - Hub Cervejeiro</title>
        <meta name="description" content="O maior hub de cervejarias artesanais do Brasil. Delivery, Menu Digital e Gestão para Cervejarias." />
      </Helmet>
      <Hero />
      <FeaturedBreweries />
      <HowItWorks />
      <BlogHighlights />
      <Pricing />
      <CallToAction />
    </>
  );
};

export default Home;